import { DeviceWithoutGatewayFormOptionsModel } from 'components/organisms/DevicesWithoutGatewayForm/models';

export interface DeviceWithoutGatewayDrawerLiteralsType {
  deviceActionButtonText: string;
  title: string;
  mainButtonText: string;
  secondaryButtonText: string;
}

export interface UpdateDeviceOptionsModel {
  literals: DeviceWithoutGatewayDrawerLiteralsType;
  formType: string;
  formOptions: DeviceWithoutGatewayFormOptionsModel;
  onOpenUpdateDeviceDrawer: (device: any) => void;
  onCloseUpdateDeviceDrawer: () => void;
  onUpdateDevice: () => void;
  updateDeviceDrawerVisible: boolean;
  loading: boolean;
  updating: boolean;
}

export enum UpdateDeviceErrorCodeType {
  CONFLICTS = 400,
  NOT_FOUND = 404,
  PAYLOAD_ERROR = 422,
}
